import FormHelper from "../../Form/FormHelper";
import {fieldData, SellFormContext} from "./SellForm";
import {useContext} from "react";

function SellFormStep({title, errors, fields}) {
    const {sellForm, updateSellForm} = useContext(SellFormContext);

    return (
        <>
            <h2 className="text-xl md:text-3xl text-primary mb-2 md:mb-4">
                {title}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
                {fields.map((field, index) => {
                    const isFullWidth = (fieldData[field].type === "preferredTitleSelect" || fieldData[field].type === "select" || fieldData[field].type === "radio") ||
                        (index % 2 === 0 && index === fields.length - 1);

                    return (
                        <div key={index}
                             className={isFullWidth ? "col-span-2" : " col-span-2 md:col-span-1"}>
                            {FormHelper.getComponent(field, fieldData, sellForm, updateSellForm, (errors && field in errors) ? errors[field] : null)}
                        </div>
                    );
                })}
            </div>
        </>
    )
}

export default SellFormStep;